import { FiSearch } from "react-icons/fi";
import PageHeaderStyleWrapper from "./PageHeader.style";
import { IoMdHome } from "react-icons/io";
import { useNavigate } from "react-router-dom";


const PageHeader = () => {

  const navigate = useNavigate();

  const navigateTo = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <PageHeaderStyleWrapper>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-5">
            <div className="breadcrumb_area">
              <h2 className="breadcrumb_title">Latest blog</h2>
              <div className="breadcrumb_menu">
                <p className="icon" onClick={() => navigateTo("/")}><IoMdHome /></p> <span>/</span> <p>Latest blog</p>
              </div>
            </div>
          </div>

          <div className="col-md-7">
            <div className="breadcrumb_form">
              <form onSubmit={(e) => e.preventDefault()}>
                <input
                  type="text"
                  id="Search"
                  name="search"
                  placeholder="Search here..."
                />
                <button>
                  <FiSearch />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </PageHeaderStyleWrapper>
  );
};

export default PageHeader;
